import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        $('.collapse.in').closest('li').addClass('active');

        let $parents = $('.documentation-left .nav-filter ul li a[data-toggle=collapse]')

        $parents.click(
            function (e) {
                e.preventDefault();

                // toggle plus/minus
                let $plus = $(this).children('span.plus');
                if ($(this).parent('li').hasClass('active')) {
                    $plus.html('+');
                } else {
                    $plus.html('–');
                }

                // toggle active classes
                if ($(this).parent().find('ul').hasClass('in')) {
                    $(this).parent().find('ul').removeClass('in');
                    $(this).parent().removeClass('active');
                } else {
                    $(this).parent().toggleClass('active');
                }
            }
        );

        // Plus/minus toggle on open/close
        $('.documentation-left .nav-filter > ul > li').each(function() {
            let $plus = $(this).find('a span.plus');
            if ($(this).hasClass('active')) {
                console.log($(this));
                $plus.html('–');
            }
        });

        // Mobile submenu functionality
        // Hamburger mobile menu button functionality
        let $docsHamburger     = $('.documentation-hamburger:not(.mobile)');
        let $docsHamburgerOpen = $('.documentation-hamburger.mobile');
        let $docsMobileMenu    = $('.documentation-header-mobile');
        $docsHamburger.click(function() {
            $(this).toggleClass('is-active');
            if ($docsMobileMenu.hasClass('nav-disabled')) {
                $docsMobileMenu.removeClass('nav-disabled');
            }
        });
        $docsHamburgerOpen.click(function() {
            if ($docsMobileMenu.hasClass('nav-disabled')) {
                $docsMobileMenu.removeClass('nav-disabled');
            } else {
                $docsMobileMenu.addClass('nav-disabled');
                $docsHamburger.toggleClass('is-active');
            }
        });

    }
}